import { createSlice } from "@reduxjs/toolkit";

const INTITIAL_DATA = {
    isAuthenticated : false,
    user : {},
    isOpenSign : false

}

export const AuthSlice = createSlice({
  name: "auth",
  initialState: INTITIAL_DATA,
  reducers: {
    openAuthModal: (state) => {
      state.isOpenSign = true
    },
    closeAuthModal: (state) => {
        state.isOpenSign = false;
    },
  },
});

export const { openAuthModal, closeAuthModal } = AuthSlice.actions;
export default AuthSlice.reducer;
